module.exports = __webpack_public_path__ + "img/2.76ea047d.png";